export function isValidDefn(defn) {
    if (!defn || !defn.goal || !defn.statsdefinition) {
        return false;
    }

    const statsDefn = (defn.statsdefinition && JSON.parse(defn.statsdefinition)) ;
    if (!statsDefn) return false;
    if (defn.goal === 'statisticalsummary') {
        return isValidStatisticalSummaryDefn(statsDefn);
    }
  return defn;
}
export function isValidStatisticalSummaryDefn(defn) {
    if (!defn || !defn.period || !defn.fields || defn.fields.length === 0) {
        return false;
    }
    for (let i = 0; i < defn.fields.length; i++) {
        if (!defn.fields[i].element || !defn.fields[i].aggregates || defn.fields[i].aggregates.length === 0) {
            return false;
        }
    }

    return defn;
}